// 本地存储用户账户信息（用于模拟登录）

let userInfo = [
  {
    'companyAccount': 'deo',
    'companySecretKey': 'deomiyao',
    'belongCompanyCode': 'DEO_SH',
    'belongCompanyName': '上海德迅科技',
    'nickname': '张三',
    'uniqueCode': 'zhangsan',
    'password': '123456'
  },
  {
    'companyAccount': 'deo',
    'companySecretKey': 'deomiyao',
    'belongCompanyCode': 'DEO_SH',
    'belongCompanyName': '上海德迅科技',
    'nickname': '李四',
    'uniqueCode': 'lisi',
    'password': '123456'
  },
  {
    'companyAccount': 'deo',
    'companySecretKey': 'deomiyao',
    'belongCompanyCode': 'DEO_SH',
    'belongCompanyName': '上海德迅科技',
    'nickname': '李有田',
    'uniqueCode': 'liyoutian',
    'password': '123456'
  },
  {
    'companyAccount': 'ai-guoji',
    'companySecretKey': 'guojisecret',
    'belongCompanyCode': 'GUOJI',
    'belongCompanyName': '国机外事',
    'nickname': '王五',
    'uniqueCode': 'wangwu',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT',
    'belongCompanyName': '智旅途',
    'nickname': '智旅途1',
    'uniqueCode': 'zlt1',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT',
    'belongCompanyName': '智旅途',
    'nickname': '智旅途2',
    'uniqueCode': 'zlt2',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT',
    'belongCompanyName': '智旅途',
    'nickname': '智旅途3',
    'uniqueCode': 'zlt3',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT-SH',
    'belongCompanyName': '上海智旅途',
    'nickname': '上海智旅途1',
    'uniqueCode': 'shzlt1',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT-SH',
    'belongCompanyName': '上海智旅途',
    'nickname': '上海智旅途2',
    'uniqueCode': 'shzlt2',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT-SH',
    'belongCompanyName': '上海智旅途',
    'nickname': '上海智旅途3',
    'uniqueCode': 'shzlt3',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT-SZ',
    'belongCompanyName': '深圳智旅途',
    'nickname': '深圳智旅途1',
    'uniqueCode': 'szzlt1',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT-SZ',
    'belongCompanyName': '深圳智旅途',
    'nickname': '深圳智旅途2',
    'uniqueCode': 'szzlt2',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT-GZ',
    'belongCompanyName': '广州智旅途',
    'nickname': '广州智旅途1',
    'uniqueCode': 'gzzlt1',
    'password': '123456'
  },
  {
    'companyAccount': 'zlt',
    'companySecretKey': 'zltmiyao',
    'belongCompanyCode': 'ZLT-GZ',
    'belongCompanyName': '广州智旅途',
    'nickname': '广州智旅途2',
    'uniqueCode': 'gzzlt2',
    'password': '123456'
  }
]

export {userInfo}



// WEBPACK FOOTER //
// ./src/assets/js/userInfo.js